import {z} from 'zod';

export const bulkDiscountFormSchema = z.object({
  discountRatio: z.number().min(0).max(100),
});

export type BulkDiscountFormType = z.infer<typeof bulkDiscountFormSchema>;
